import Text from 'common/components/Text';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    title: string;
}

interface Props<T> {
    form: ObservableForm<T>;
    placeholderText?: string;
}

const TitleField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    placeholderText,
}) => {
    return (
        <Field
            form={form}
            name="title"
            title={__('Name your project')}
            required={true}
            render={() => (
                <Text placeholder={placeholderText} fill={true} {...form.attach('title')} />
            )}
        />
    );
};

export default TitleField;
